define([
    'edge/platform/widgets/basicinputs/CtrlGroupDirective',
    './InlineCtrlGroupDirective',
    './InputCtrlDirective',
    './InlineInputCtrlDirective',
    './NgFormDecorator',
    'edge/platform/widgets/datetimepicker/module',
    'edge/platform/widgets/select/module'
], (CtrlGroupDirective, InlineCtrlGroupDirective, InputCtrlDirective, InlineInputCtrlDirective, NgFormDecorator)=> {
    return angular.module('edge.platform.widgets.basicinputs', [
        'edge.platform.widgets.ui.bootstrap.datetimepicker',
        'edge.platform.widgets.select'
    ])
        .config(['$provide', ($provide)=> {
            $provide.decorator('ngFormDirective', NgFormDecorator);
        }])
        .config(['$provide', ($provide)=> {
            $provide.decorator('formDirective', NgFormDecorator);
        }])
        .directive('gwPlCtrlGroup', CtrlGroupDirective)
        .directive('gwPlInlineCtrlGroup', InlineCtrlGroupDirective)
        .directive('gwPlInputCtrl', InputCtrlDirective)
        .directive('gwPlInlineInputCtrl', InlineInputCtrlDirective);
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/basicinputs/module.js